import { useQuery } from '@tanstack/react-query';

import { getUrlToBackendApi, request } from '@shared/services/api';

import { PromotionDetailedType } from '@types';

const ALL_PROMOTIONS_REQUEST_URL = '/lotteries';

export const GET_ALL_PROMOTIONS_QUERY_KEY = ['promotion'];

export const useQuerySinglePromotion = (id: string, per_page: number, page: number) => {
	return useQuery<unknown, unknown, PromotionDetailedType>({
		queryKey: [GET_ALL_PROMOTIONS_QUERY_KEY, id, page],
		queryFn: () => {
			return request<PromotionDetailedType>({
				method: 'get',
				url: getUrlToBackendApi(ALL_PROMOTIONS_REQUEST_URL + '/' + id + '?page=' + page + '&per_page=' + per_page).href
			});
		},
		retry: false
	});
};
